import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const BackupSettings: React.FC = () => {
  return (
    <Card>
      <Title level={4}>Backup Settings</Title>
      <p>Configure automatic backup schedules and storage locations.</p>
      <p>Manage backup retention and encryption settings.</p>
    </Card>
  );
};

export default BackupSettings; 